import { render, staticRenderFns } from "./BaseCode.vue?vue&type=template&id=33fa7c7e"
import script from "./BaseCode.vue?vue&type=script&lang=js"
export * from "./BaseCode.vue?vue&type=script&lang=js"
import style0 from "./BaseCode.vue?vue&type=style&index=0&id=33fa7c7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports